import { render, staticRenderFns } from "./AppointmentsTab.vue?vue&type=template&id=1c80e326"
import script from "./AppointmentsTab.vue?vue&type=script&lang=js"
export * from "./AppointmentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports